<template>
  <vx-card no-shadow>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-2/5 w-full">
        <h2>Participants</h2>
      </div>
    </div>

    <vs-button color="success" @click="onNotifyParticipants" class="ml-auto mt-2">Notify Participants</vs-button>

    <vs-table 
      v-if="venueTrainingInstance"
      ref="table" 
      class="mt-8" 
      v-model="selected" 
      pagination 
      :max-items="itemsPerPage" 
      search 
      :data="venueTrainingInstance.participants">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span v-if="venueTrainingInstance" class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ venueTrainingInstance.participants.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : venueTrainingInstance.participants.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="displayName">Name</vs-th>
        <vs-th sort-key="hasCompleted">Completed</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.displayName }}</p>
            </vs-td>
            <vs-td>
              <p v-if="tr.hasCompleted" class="product-category">{{ tr.completedOn | formatDate }}</p>
              <p v-if="!tr.hasCompleted" class="product-category">No</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup
      title="Notify Participants"
      :active.sync="notifyParticipantsPopupActive"
    >
      <div>
        <p>Subject:</p>
        <vs-input class="mt-2 w-full" v-model="notificationTitle" />

        <p class="mt-4">Text:</p>
        <vs-input class="mt-2 w-full" v-model="notificationBody" />

        <vs-button 
          @click="sendParticipantNotifications"
          class="mt-10"
          color="primary" type="filled" icon-pack="feather" icon="done">
          Send Notification
        </vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
export default {
  props: {
    venueTrainingInstance: Object
  },
  data () {
    return {
      venueTrainingId: '',
      
      query: '*',

      selected: [],
      itemsPerPage: 100,
      isMounted: false,

      notifyParticipantsPopupActive: false,
      notificationTitle: '',
      notificationBody: ''
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.venueTrainingInstance.length
    }
  },
  methods: {
    onNotifyParticipants: function () {
      this.notifyParticipantsPopupActive = true;
    },

    sendParticipantNotifications: function () {
      this.notifyParticipantsPopupActive = false;

      this.$vs.loading()

      const url = process.env.VUE_APP_API +'/VenueTraining/' + this.venueTrainingId + '/info/notify';

      const payload = {
        title: this.notificationTitle,
        body: this.notificationBody
      };

      this.$http.post(url, payload)
        .then((/*resp*/) => {
          this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Participants notified'
            });
        })
        .catch(err => {
          console.log(err)
          this.$vs.notify({
              color:'error',
              title:'Error',
              text:'Could not notify participants'
            });
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  },
  created() {
    this.venueTrainingId = this.$route.params.venueTrainingId;
  },
  mounted () {
    this.isMounted = true
  }
}
</script>